import template from 'promo-rotational-banner.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';

function firstRender(store) {
    this.render(store, this);
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-secondary-footer-promo',
        name: 'secondaryFooterPromoComponent',
        renderType: dDom,
        firstRender: firstRender,
        template: template,
        watch: 'core.secondaryFooterPromo'
    };

    return generate(config, store, overrides);
}
